import { API } from '../../utils';
import {
  ProviderBusinessTypePermissionsDTO,
  ProviderPermissionsDTO,
  WorkerDashboardStatsDTO,
  CreateVisitStatProps,
} from './types';
import { GW_SERVICES_PREFIXES } from '../../constants';

const { C300, AUTHORIZATION } = GW_SERVICES_PREFIXES;

/* Получение всех разделов системы */
export const GetDashboardSections = () =>
  API.get(`/${C300}/models/dashboard_sections/`);

/* Получение всех прав, разрешённых видам деятельности организации */
export const GetProviderBusinessTypePermissions =
  (): Promise<ProviderBusinessTypePermissionsDTO> =>
    API.get(
      `/${AUTHORIZATION}/permissions/current_company_business_type_permissions/`
    );

/* Получение прав организации с учётом её видов деятельности */
export const GetProviderPermissions = (
  providerId: string
): Promise<ProviderPermissionsDTO> =>
  API.get(`/${AUTHORIZATION}/permissions/permissions_admin/${providerId}/`);

/* Статистика сотрудника */
export const GetWorkerDashboardStats = (): Promise<WorkerDashboardStatsDTO> =>
  API.get(`/${C300}/models/worker_dashboard_stats/`);

/* Отметить посещение раздела */
export const CreateVisitStat = (data: CreateVisitStatProps) =>
  API.gatewayPost(`/${C300}/models/worker_dashboard_stats/`, data);
